import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';

import { LockIconSimple } from 'src/assets/lock-icon-simple';
import { KIOSK_PRO_MEDIA, LoginOptionsTitle } from '../../kiosk-pro-shared/kiosk-pro-shared.styles';
import { LoginOptionsTitleContainer, SubText } from '../kiosk-login-options.styles';
import { IconContainer } from './phone-number-login.styles';
import { GuestButton } from './guest-login.styles';

// ECOMM-13062: shown instead of QR / phone sign-in when the server reports the session can't be
// used to sign in (the dispensary requires paired kiosks and this one isn't paired). Guest
// checkout stays available; the button sends staff to the PIN setup screen. Laid out like the
// sibling cards (title + subtext, icon circle, outlined button) so the card doesn't look empty.
export function KioskLoginUnavailable({ setupUrl }: { setupUrl: string }): JSX.Element {
  return (
    <Container data-testid='kiosk-pro-login-unavailable'>
      <LoginOptionsTitleContainer>
        <LoginOptionsTitle>Sign-in isn&apos;t set up on this kiosk</LoginOptionsTitle>
        <SubText>You can still shop as a guest. Staff can enable sign-in with the kiosk&apos;s PIN.</SubText>
      </LoginOptionsTitleContainer>

      <IconContainer>
        <ThemedLockIcon aria-hidden='true' color='currentColor' strokeWidth='1.5' />
      </IconContainer>

      {/* Outlined (secondary), like "Shop as guest": a staff action that shouldn't outrank the
          customer's options. */}
      <GuestButton forwardedAs={Link} href={setupUrl} data-testid='kiosk-pro-setup-kiosk-button'>
        Set up this kiosk
      </GuestButton>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 36px;
  max-width: 640px;
  text-align: center;
  text-wrap: balance;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 24px;
  }
`;

const ThemedLockIcon = styled(LockIconSimple).attrs({ width: 96, height: 104 })`
  color: var(--dcm-kiosk-login-unavailable-icon-color, ${({ theme }) => theme.colors.grey[30]});

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    width: 72px;
    height: 78px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    width: 52px;
    height: 56px;
  }
`;
